var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7492 29C22.4478 29 28.8454 19.3828 28.8454 11.043C28.8454 10.7699 28.8398 10.498 28.8274 10.2273C30.0722 9.33345 31.1466 8.22678 32 6.95913C30.8604 7.46187 29.634 7.80025 28.3475 7.95281C29.6607 7.1715 30.6688 5.93544 31.1444 4.46206C29.8959 5.197 28.53 5.71509 27.1057 5.994C25.9451 4.76725 24.2928 4 22.4632 4C18.9508 4 16.1026 6.82637 16.1026 10.3103C16.1026 10.8056 16.1585 11.2873 16.2676 11.7494C10.9816 11.4854 6.29426 8.97406 3.15727 5.15538C2.59227 6.11852 2.29509 7.21316 2.29608 8.3275C2.29608 10.5171 3.41888 12.4501 5.1264 13.5809C4.11638 13.5503 3.12854 13.2796 2.24592 12.7916C2.24498 12.8181 2.24498 12.8439 2.24498 12.8722C2.24498 15.9286 4.43728 18.4806 7.3475 19.0588C6.80092 19.2065 6.23691 19.2812 5.67041 19.2809C5.2613 19.2809 4.86259 19.2409 4.47509 19.1671C5.2848 21.6747 7.63274 23.4996 10.4165 23.5506C8.23963 25.2436 5.49746 26.2521 2.51711 26.2521C2.01011 26.2525 1.50353 26.2233 1 26.1646C3.81483 27.9549 7.15715 28.9996 10.7495 28.9996",
    fill: "#8E9193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.22d322bd.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7492 29C22.4478 29 28.8454 19.3828 28.8454 11.043C28.8454 10.7699 28.8398 10.498 28.8274 10.2273C30.0722 9.33345 31.1466 8.22678 32 6.95913C30.8604 7.46187 29.634 7.80025 28.3475 7.95281C29.6607 7.1715 30.6688 5.93544 31.1444 4.46206C29.8959 5.197 28.53 5.71509 27.1057 5.994C25.9451 4.76725 24.2928 4 22.4632 4C18.9508 4 16.1026 6.82637 16.1026 10.3103C16.1026 10.8056 16.1585 11.2873 16.2676 11.7494C10.9816 11.4854 6.29426 8.97406 3.15727 5.15538C2.59227 6.11852 2.29509 7.21316 2.29608 8.3275C2.29608 10.5171 3.41888 12.4501 5.1264 13.5809C4.11638 13.5503 3.12854 13.2796 2.24592 12.7916C2.24498 12.8181 2.24498 12.8439 2.24498 12.8722C2.24498 15.9286 4.43728 18.4806 7.3475 19.0588C6.80092 19.2065 6.23691 19.2812 5.67041 19.2809C5.2613 19.2809 4.86259 19.2409 4.47509 19.1671C5.2848 21.6747 7.63274 23.4996 10.4165 23.5506C8.23963 25.2436 5.49746 26.2521 2.51711 26.2521C2.01011 26.2525 1.50353 26.2233 1 26.1646C3.81483 27.9549 7.15715 28.9996 10.7495 28.9996",
    fill: "#8E9193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.22d322bd.svg";
export { ForwardRef as ReactComponent };